(function () {
  // bbWK52PromoTag and bbWK52PromoMultiplier are injected by Liquid in the section template.
  var promoTag = window.bbWK52PromoTag;
  var promoMultiplier = window.bbWK52PromoMultiplier || 0.5;
  var tagCache = Object.create(null); // handle → true | false

  function getHandleFromCard(card) {
    var link = card.querySelector('.ns-details > a');
    if (!link) return null;
    var match = link.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function applyPromoPrice(card) {
    if (card.dataset.bbPromoApplied) return;

    var priceEl = card.querySelector('.ns-details .ns-price');
    if (!priceEl) return;

    var priceText = priceEl.textContent.trim();
    var match = priceText.match(/([\D]*)(\d+(?:\.\d+)?)(.*)/);
    if (!match) return;

    var prefix = match[1];
    var amount = parseFloat(match[2]);
    var suffix = match[3];
    var promoAmount = Math.round(amount * promoMultiplier);

    var existingStrike = card.querySelector('.ns-list-price, .ns-original-price, s, del');

    observer.disconnect();
    if (existingStrike) {
      priceEl.textContent = prefix + promoAmount + suffix;
    } else {
      priceEl.innerHTML =
        '<s style="opacity:0.6">' + priceText + '</s>' +
        ' ' + prefix + promoAmount + suffix;
    }
    observer.observe(target, { childList: true, subtree: true });

    card.dataset.bbPromoApplied = '1';
  }

  function checkCard(card) {
    if (card.dataset.bbPromoApplied || card.dataset.bbPromoChecking) return;
    if (!promoTag) return;

    var handle = getHandleFromCard(card);
    if (!handle) return;

    if (tagCache[handle] === true) { applyPromoPrice(card); return; }
    if (tagCache[handle] === false) return;

    card.dataset.bbPromoChecking = '1';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var isPromo = Array.isArray(data.tags) && data.tags.indexOf(promoTag) !== -1;
        tagCache[handle] = isPromo;
        if (isPromo) applyPromoPrice(card);
      })
      .catch(function () { tagCache[handle] = false; });
  }

  function processGrid() {
    document.querySelectorAll('#ns-product-grid .ns-product').forEach(checkCard);
  }

  var target = document.querySelector('#ns-product-grid') || document.body;
  var observer = new MutationObserver(function (mutations) {
    var hasNewCards = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return (
          n.nodeType === 1 &&
          ((n.classList && n.classList.contains('ns-product')) ||
            (n.querySelector && n.querySelector('.ns-product')))
        );
      });
    });
    if (hasNewCards) processGrid();
  });
  observer.observe(target, { childList: true, subtree: true });

  processGrid();
})();
